<template>
    <button
        :type="type"
        :class="[
            'inline-flex items-center px-4 py-2 rounded-md text-xs text-white uppercase tracking-widest transition ease-in-out duration-150 disabled:opacity-50 disabled:pointer-events-none',
            color,
            { default: !color },
            { danger: danger },
            { success: success },
            { small: small },
        ]"
    >
        <slot />
    </button>
</template>
<script setup>
defineProps({
    type: {
        type: String,
        required: false,
        default: 'button',
    },
    color: {
        type: String,
        required: false,
    },
    danger: {
        type: Boolean,
        required: false,
    },
    success: {
        type: Boolean,
        required: false,
    },
    small: {
        type: Boolean,
        required: false,
    },
});
</script>
<style lang="scss" scoped>
@use '@/scss/variables' as vars;

.default {
    background-color: vars.$blackColor;
    &:hover {
        background-color: vars.$lightBlackColor;
    }
}

.green {
    background-color: vars.$greenColor;
    &:hover {
        background-color: vars.$lightGreenColor;
    }
}

.red {
    background-color: vars.$redColor;
    &:hover {
        background-color: vars.$lightRedColor;
    }
}

.blue {
    background-color: vars.$blueColor;
    &:hover {
        background-color: vars.$lightBlueColor;
    }
}

.white {
    background-color: vars.$whiteColor;
    color: vars.$blackColor !important;
    &:hover {
        background-color: vars.$lightWhiteColor;
    }
}

.danger {
    background-color: vars.$dangerColor;
    &:hover {
        background-color: vars.$lightDangerColor;
    }
}

.success {
    background-color: vars.$successColor;
    &:hover {
        background-color: vars.$lightSuccessColor;
    }
}

.small {
    font-size: 0.7rem;
    padding: 0.4rem 0.6rem !important;
}
</style>
